import { schema } from 'normalizr';

const USER_SCHEMA = new schema.Entity('users', {}, { idAttribute: '@id' });
const CONTACT_USER_SCHEMA = new schema.Entity('contactUsers', {}, { idAttribute: '@id' });

export default {
  User: USER_SCHEMA,
  ContactUser: CONTACT_USER_SCHEMA,
};
